/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * * `None` - NONE
 * * `Prompt` - PROMPT
 * * `Api` - API
 * * `Local` - LOCAL
 */
export enum ExecutionMode {
  NONE = 'None',
  PROMPT = 'Prompt',
  API = 'Api',
  LOCAL = 'Local',
}
